import { createContext, ReactNode, useContext } from 'react'
import { UserV1 } from '@tovala/browser-apis-combinedapi'

const UserContext = createContext<
  | {
      user: UserV1
    }
  | undefined
>(undefined)

const UserProvider = ({
  children,
  user,
}: {
  children: ReactNode
  user: UserV1
}): JSX.Element => {
  return (
    <UserContext.Provider value={{ user }}>{children}</UserContext.Provider>
  )
}

function useUser() {
  const context = useContext(UserContext)
  if (context === undefined) {
    throw new Error('useUser must be used in a UserProvider')
  }

  return context
}

export { UserProvider, useUser }
